import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import "./App.scss";
import icon from "./assets/img/icon.png";
import logo from "./assets/img/logo_eclesial_login.svg";
import api from "./services/api";
import apiLgpd from "./services/apiLgpd";

function App() {
  const params = new URL(document.location).searchParams;
  const paramGuid = params.get("guid");
  const paramConsentimento = params.get("consentimento");
  const apiParaUsar = paramGuid ? api : paramConsentimento ? apiLgpd : null;
  const paramParaUsar = paramGuid
    ? `/ConfirmarEmail?guid=${paramGuid}`
    : paramConsentimento
      ? `/AceiteToken/${paramConsentimento}`
      : null;
  const METHOD = paramGuid ? "post" : "get";

  const [message, setMessage] = useState("Confirmando email!");
  const [loadVisible, setLoadVisible] = useState(true);

  useEffect(() => {
    if (paramParaUsar) {
      async function validaEmail() {
        await apiParaUsar[METHOD](`${paramParaUsar}`)
          .then((res) => {
            setLoadVisible(false);
            setMessage(
              paramGuid
                ? res.data.message
                : `Consentimento realizado com sucesso.`,
            );
          })
          .catch((error) => {
            const MENSAGEM = paramGuid ? error.message : `Token inválido`;
            setLoadVisible(false);
            setMessage(MENSAGEM);
          });
      }
      validaEmail();
    } else {
      setMessage(`Nenhum parâmetro encontrado.`);
      setLoadVisible(false);
    }
  }, []);

  const loader = () => {
    return (
      <ThreeDots
        class="loading"
        color="#00BFFF"
        height={30}
        width={100}
        visible={loadVisible}
      />
    );
  };

  return (
    <div className="app">
      <div className="app-header">
        {<img src={logo} className="app-logo" alt="logo" />}
      </div>
      <div className="main">
        <div className="loading">
          {<img src={icon} className="app-icon" alt="icone" />}
          {loader()}
          <p className="msg">{message}</p>
        </div>
      </div>
      <div className="app-footer"></div>
    </div>
  );
}

export default App;
